module.exports = __webpack_public_path__ + "img/统计分析.08924bb6.jpg";